import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getTableColumns } from './columns';
import { isMobile } from '../../../../services/clientService';
import {
  setCurrentPage,
  setPageSize,
} from '../../../../reducer/DealSubmission/actions';
import { getAllAgents } from '../../../../reducer/User/actions';

import './index.scss';

const tableScroll = {
  scrollToFirstRowOnChange: true,
  x: isMobile() ? true : 'max-content',
};
const DealSubmissionTable = ({ searchCriteria, setSearchCriteria }) => {
  const { isLoading, total, dealSubmissions, currentPage, pageSize } =
    useSelector(({ DealSubmissionReducer }) => DealSubmissionReducer);
  const { agents } = useSelector(({ UserReducer }) => UserReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllAgents()); // Fetch agents on component mount
  }, [dispatch]);
  const locale = {
    emptyText: isLoading ? null : <p>No Record Found.</p>,
  };

  const onShowSizeChange = (changedPage, changedCurrentPageSize) => {
    if (changedPage - 1 !== currentPage) {
      dispatch(setCurrentPage({ page: changedPage - 1 }));
    }
    if (pageSize !== changedCurrentPageSize) {
      dispatch(setPageSize({ pageSize: changedCurrentPageSize }));
    }
  };

  const pagination = {
    position: ['topRight'],
    onChange: onShowSizeChange,
    total,
    pageSize,
    current: currentPage + 1,
    showTotal: (totalItems, range) =>
      `${range[0]}-${range[1]} of ${new Intl.NumberFormat('en-US').format(
        totalItems,
      )} items`,
  };

  const onTableChange = (_pagination, filters) => {
    const nextFilter = filters?.source?.[0] || undefined;

    if (
      (searchCriteria?.leadSourceFilter || undefined) !== nextFilter &&
      typeof setSearchCriteria === 'function'
    ) {
      dispatch(setCurrentPage({ page: 0 }));
      setSearchCriteria((prev) => ({
        ...(prev || {}),
        leadSourceFilter: nextFilter,
      }));
    }
  };

  return (
    <Table
      rowKey="_id"
      className="deal-submission-table"
      loading={isLoading}
      columns={getTableColumns(agents)}
      dataSource={dealSubmissions}
      scroll={tableScroll}
      pagination={pagination}
      locale={locale}
      onChange={onTableChange}
    />
  );
};

export default DealSubmissionTable;
